import { useTranslation } from "react-i18next";
import Reveal from "@/components/base/Reveal";

export default function PricingCTA() {
  const { t } = useTranslation();

  return (
    <section className="relative bg-deepblack py-32 md:py-44 overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0"
      >
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20luxury%20private%20music%20studio%20control%20room%20at%20night%20mixing%20console%20with%20warm%20amber%20glow%20from%20monitors%20deep%20black%20and%20charcoal%20interior%20velvet%20acoustic%20panels%20champagne%20gold%20accent%20lighting%20from%20recessed%20fixtures%20ultra%20high-end%20executive%20atmosphere%20minimalist%20serene%20professional%20architectural%20photography%20no%20text%20no%20logos&width=1920&height=800&seq=5&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-deepblack/60 via-deepblack/80 to-deepblack/95"
        />
      </div>

      <Reveal>
        <div className="relative z-10 w-full px-6 md:px-12 lg:px-16 text-center"
        >
          <span className="inline-block px-4 py-1.5 border border-champagne/40 rounded-full text-champagne text-xs font-sans tracking-widest uppercase mb-8"
          >
            {t("pricing.cta.tag")}
          </span>

          <h2 className="font-serif text-marble leading-tight mb-6">
            <span className="text-4xl md:text-6xl lg:text-7xl font-light tracking-wide">
              {t("pricing.cta.title")}
            </span>
          </h2>

          <p className="text-marble/50 text-sm md:text-base font-sans leading-relaxed max-w-lg mx-auto mb-12 whitespace-pre-line"
          >
            {t("pricing.cta.desc")}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4"
          >
            <a
              href="/inquiry"
              className="inline-flex items-center gap-3 bg-champagne hover:bg-champagne/90 text-deepblack px-8 py-3.5 rounded-full text-sm font-sans tracking-widest uppercase transition-all duration-300"
            >
              {t("pricing.cta.button1")}
            </a>
            {t("pricing.cta.button2") && (
              <a
                href="#plans"
                className="inline-flex items-center gap-3 border border-marble/30 hover:border-marble/50 text-marble px-8 py-3.5 rounded-full text-sm font-sans tracking-widest uppercase transition-all duration-300"
              >
                {t("pricing.cta.button2")}
              </a>
            )}
          </div>
        </div>
      </Reveal>
    </section>
  );
}